<script>
export default {
  name: 'App',
  provide() {
    return {
      previewImage: this.previewImage,
    }
  },
  data() {
    return {
      previewImageVisible: false,
      previewImageUrl: '',
    }
  },
  created() {
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store')),
        ),
      )
      sessionStorage.removeItem('store')
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })

    this.$store.commit('setRoleId', +localStorage.getItem('roleId') || +sessionStorage.getItem('roleId') || '')
  },
  methods: {
    previewImage(url) {
      this.previewImageUrl = url
      this.previewImageVisible = true
    },
  },
}
</script>

<template>
  <div id="app">
    <RouterView />
    <ElDialog
      :visible.sync="previewImageVisible"
      width="60%"
    >
      <img :src="previewImageUrl">
    </ElDialog>
  </div>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .el-descriptions .is-bordered .el-descriptions-item__cell,
  .el-table__cell,
  .el-table--border {
    border-color: gray;
  }

  .el-table--border {
    border-style: solid;
    border-width: 1px;
  }

  .el-statistic {
    .title {
      font-size: medium;
    }
    .number {
      font-size: large;
    }
  }
}

.el-cascader-menu__wrap {
  height: 400px !important;
}

.el-loading-spinner svg {
  display: inline;
}
</style>
